import { formatResolution } from '../../../../../core/components/tooltip/utils/resolution-formatter.js';
import {
  FormatterWithPrecision,
  type TimeFrameFormatter,
} from '../../../../../core/types/formatter.js';
import { XYAccessorDataTypes } from '../../../../types/xy-chart.js';
import {
  isCategoricalTooltip,
  isNumericalToolTip,
  isTimeTooltip,
} from '../../../../utils/type-guards.js';

export function getClosestPointTooltipBodyContent(
  [v0, v1]: [v0?: XYAccessorDataTypes, v1?: XYAccessorDataTypes],
  formatter?: FormatterWithPrecision | TimeFrameFormatter,
  toPercentage?: (value: number) => number,
) {
  let text = '';
  let duration: string | undefined;

  const displayValue = v0 ?? v1;
  if (displayValue === undefined) {
    return { text, duration };
  }

  const hasRange = v0 !== undefined && v1 !== undefined && v0 !== v1;
  const args = {
    formatter,
    v0: displayValue,
    v1,
  };

  if (isCategoricalTooltip(args)) {
    if (hasRange) {
      text = `${v0} - ${v1}`;
    } else {
      text = args.v0;
    }
  } else if (isNumericalToolTip(args)) {
    if (hasRange) {
      text = `${args.formatter(args.v0)}${
        toPercentage ? ' (' + toPercentage(args.v0) + '%)' : ''
      } - ${args.formatter(args.v1)}${
        toPercentage ? ' (' + toPercentage(args.v1) + '%)' : ''
      }`;
    } else {
      text = `${args.formatter(args.v0)}${
        toPercentage ? ' (' + toPercentage(args.v0) + '%)' : ''
      }`;
    }
  } else if (isTimeTooltip(args)) {
    text = `${args.formatter(args.v0, args.v1)}`;
    duration = formatResolution(args.v0, args.v1);
  }

  return { duration, text };
}
